module.exports = __webpack_public_path__ + "static/media/em-101.233be055.png";